/**
 * Introduction 获取屏幕的高度
 *
 * @author 刘维中
 * @email weizhong.liu@gmail.com
 * @since 1.0
 * @date 2020/10/11
 * @returns {number}
 */
function screenHeight ()
{
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
}

/**
 * Introduction 获取屏幕的宽度
 *
 * @author 刘维中
 * @email weizhong.liu@gmail.com
 * @since 1.0
 * @date 2020/10/11
 * @returns {number}
 */
function screenWidth ()
{
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
}

/**
 * Introduction 数据对象深拷贝
 *
 * @author 刘维中
 * @email weizhong.liu@gmail.com
 * @since 1.0
 * @date 2020/10/11
 * @param obj
 * @returns {[]|*}
 */
function deepClone (obj)
{
    let result = typeof obj.splice === 'function' ? [] : {}
    let key
    if ( obj && typeof obj === 'object' )
    {
        for ( key in obj )
        {
            if ( obj[ key ] && typeof obj[ key ] === 'object' )
            {
                result[ key ] = tools.deepClone(obj[ key ]) // 如果对象的属性值为object的时候，递归调用deepClone，即再把某个值对象复制一份到新的对象的对应值中
            } else
            {
                result[ key ] = obj[ key ] // 如果对象的属性值不为object的时候，直接复制参数对象的每一个键/值到新对象对应的键/值中
            }
        }
        return result
    }

    return obj
}

/**
 * Introduction 计算两个坐标之间的距离
 *
 * @author 刘维中
 * @email weizhong.liu@gmail.com
 * @since 1.0
 * @date 2020/10/11
 * pos1 = {x: , y: , z: }
 * pos2 = {x: , y: , z: }
 */
function calculateCoordinatePosition (pos1, pos2)
{
    const xPos = Math.pow(pos1.x - pos2.x, 2)
    const yPos = Math.pow(pos1.y - pos2.y, 2)
    const zPos = Math.pow(pos1.z - pos2.z, 2)

    return Math.abs(Math.sqrt(xPos + yPos + zPos))
}

export default {
    screenHeight: screenHeight,
    screenWidth: screenWidth,
    deepClone: deepClone,
    calculateCoordinatePosition: calculateCoordinatePosition
}
